import React, { useMemo } from 'react';
import { Activity, BedDouble, AlertTriangle, Clock } from 'lucide-react';

export default function GlobalIndicators({ reservations = [], beds = [] }) {

    const metrics = useMemo(() => {
        // 1. Ocupação Geral
        const totalBeds = beds.length;
        const occupiedBeds = beds.filter(b => b.statusId === 2 || b.statusId === 5 || b.statusId === 6 || b.statusId === 7).length; // Ajustar IDs conforme statusModel
        const occupancyRate = totalBeds > 0 ? Math.round((occupiedBeds / totalBeds) * 100) : 0;

        // 2. Em Liberação (Check-out feito, mas não disponível)
        // Status: 8 (Aguardando Higienização), 9 (Em Higienização), 10 (Reservado - fluxos paralelos)
        // Assumindo IDs baseados no conhecimento anterior.
        const inReleaseProcess = beds.filter(b => [8, 9, 10].includes(b.statusId)).length;

        // 3. Reservas Críticas (Ex: Alta prioridade há mais de 2h - simulado por enquanto)
        const criticalReservations = reservations.filter(r => r.priority === 'Alta' && r.status === 'pending').length;

        // 4. Tempo Médio de Espera (Simulado ou calculado se tiver created_at)
        const pending = reservations.filter(r => r.status === 'pending');
        const avgWait = pending.length > 0 ? "45m" : "0m"; // Placeholder para cálculo real depois

        return {
            occupancyRate,
            inReleaseProcess,
            criticalReservations,
            avgWait
        };
    }, [reservations, beds]);

    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
            {/* Card Ocupação */}
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm flex items-center justify-between">
                <div>
                    <p className="text-sm text-gray-500 dark:text-gray-400 font-medium">Ocupação Geral</p>
                    <h3 className={`text-2xl font-bold ${metrics.occupancyRate > 90 ? 'text-red-500' : 'text-gray-800 dark:text-white'}`}>
                        {metrics.occupancyRate}%
                    </h3>
                </div>
                <div className={`p-3 rounded-full ${metrics.occupancyRate > 90 ? 'bg-red-50 text-red-500' : 'bg-blue-50 text-blue-500'}`}>
                    <Activity size={24} />
                </div>
            </div>

            {/* Card Em Liberação */}
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm flex items-center justify-between">
                <div>
                    <p className="text-sm text-gray-500 dark:text-gray-400 font-medium">Em Preparação</p>
                    <h3 className="text-2xl font-bold text-gray-800 dark:text-white">{metrics.inReleaseProcess}</h3>
                    <p className="text-xs text-green-600 mt-1">Leitos pós-alta</p>
                </div>
                <div className="p-3 rounded-full bg-orange-50 text-orange-500">
                    <BedDouble size={24} />
                </div>
            </div>

            {/* Card Críticos */}
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm flex items-center justify-between">
                <div>
                    <p className="text-sm text-gray-500 dark:text-gray-400 font-medium">Fila Crítica</p>
                    <h3 className="text-2xl font-bold text-gray-800 dark:text-white">{metrics.criticalReservations}</h3>
                    <p className="text-xs text-red-500 mt-1">Prioridade Alta</p>
                </div>
                <div className="p-3 rounded-full bg-red-50 text-red-500">
                    <AlertTriangle size={24} />
                </div>
            </div>

            {/* Card Tempo Espera */}
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm flex items-center justify-between">
                <div>
                    <p className="text-sm text-gray-500 dark:text-gray-400 font-medium">Tempo Médio</p>
                    <h3 className="text-2xl font-bold text-gray-800 dark:text-white">{metrics.avgWait}</h3>
                    <p className="text-xs text-gray-400 mt-1">Últimas 4h</p>
                </div>
                <div className="p-3 rounded-full bg-gray-50 text-gray-500 dark:bg-gray-700">
                    <Clock size={24} />
                </div>
            </div>
        </div>
    );
}
